module.exports = __webpack_public_path__ + "img/calif_es.91146f31.jpg";